import { render, staticRenderFns } from "./bpc-router-link.vue?vue&type=template&id=d4f42924&"
import script from "./bpc-router-link.vue?vue&type=script&lang=js&"
export * from "./bpc-router-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports